import { Grid as MaterialGrid, LinearProgress } from "@material-ui/core";
import { noop } from "lodash";
import { FunctionComponent } from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../../components/button";
import { dueDiligenceIconMap } from "../../../../../components/icons/due-diligence-status";
import { Grid } from "../../../../../components/layout";
import { Widget } from "../../../../../components/widget";
import { VerificationDTO } from "../../../../../store/verification/models/dto/due-diligence";
import { VerificationService } from "../../../../../store/verification/service";

interface IOverviewProps {
  item: VerificationDTO.Responses.DueDiligence.Form.Get.T;
  configId: VerificationDTO.Responses.DueDiligence.Config.Get.T["id"];
}

const Wrapper = styled.div`
  margin-top: 1em;
`;

const Overview: FunctionComponent<IOverviewProps> = ({ item, configId }) => {
  return (
    <Wrapper>
      <Grid col-lg={2} col-xs={1}>
        <Widget title="Overview">
          <MaterialGrid container spacing={3}>
            <MaterialGrid item xs={6}>
              Status
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              {dueDiligenceIconMap[item.status]}
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              KYCs Processed
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              <LinearProgress
                value={(item.kycProcessed / item.totalKycToBeProcessed) * 100}
                variant="determinate"
              />
              {item.kycProcessed} / {item.totalKycToBeProcessed}
            </MaterialGrid>
          </MaterialGrid>
        </Widget>
        <Widget title="Contact Details">
          <MaterialGrid container spacing={3}>
            <MaterialGrid item xs={6}>
              Name
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              {item.contactDetails.firstName} {item.contactDetails.middleName}{" "}
              {item.contactDetails.lastName}
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              Phone
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              {item.contactDetails.phone}
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              E-mail
            </MaterialGrid>
            <MaterialGrid item xs={6}>
              {item.contactDetails.emailAddress}
            </MaterialGrid>
            {item.status === "PENDING" ? (
              <MaterialGrid item xs={6}>
                <PrimaryButton
                  onClick={() =>
                    VerificationService.resendEmailToContactPerson(
                      configId
                    ).catch(noop)
                  }
                >
                  Resend E-mail
                </PrimaryButton>
              </MaterialGrid>
            ) : null}
          </MaterialGrid>
        </Widget>
      </Grid>
    </Wrapper>
  );
};

export default Overview;
